<template>
  <b-row>
    <b-col lg="4" md="4" sm="6">
      <div class="field">
        <label>{{ $t('Request.' + codeTitle) }}</label>
        <p class="bold-heading">{{ requestData.DocNo }}</p>

      </div>
      <div class="field" v-if="CategoryHide">
        <Dropdown :label="$t('Request.Category')" v-model="requestData.Category" :items="Request.category"
          placeholder="" name="Category" id="Category" :show-clear="false" />
      </div>

    </b-col>

    <b-col lg="4" sm="12" class="d-flex mt-3">
      <div class="location-line position-relative ms-3 w-100" v-if="IndentFlag == true">
        <b-row class="pb-0">
          <b-col class="pb-2">
            <p class="light-txt mt-4">{{ storeDetails.FromStoreCode }}</p>
            <p class="light-txt">{{ storeDetails.FromStoreName }}</p>
            <img class="location-icon1" src="../../../../../assets/Img/icons/location.svg" />
          </b-col>
          <b-col class="d-flex flex-direction-column align-items-end text-end">
            <img class="location-icon2" src="../../../../../assets/Img/icons/location.svg" />
            <p class="light-txt  mt-4">{{ storeDetails.ToStoreCode }}</p>
            <p class="light-txt">{{ storeDetails.ToStoreName }}</p>
          </b-col>
        </b-row>

      </div>
    </b-col>
    <b-col lg="4" md="4" sm="6">
      <div class="field d-flex align-items-center" v-if="UrgentFlag">
        <Checkbox v-model="requestData.Remarkscheck" inputId="UrgentRequest" name="urgentrequest"
          @change="checkboxupdate()" binary />
        <label for="urgentrequest" class="ms-2 mb-0 mt-1"> {{ $t('Request.markasurgent') }} </label>
      </div>
      <div class="field">
        <TextArea v-model="requestData.Remarks" :required-icon="false" name="Remark" id="Remark"
          :label="$t('Request.remarks')" :rules="{ required: false }" :disabled="false" @update:modelValue="update"
          :rows="3" />
      </div>
    </b-col>
  </b-row>
</template>
<script lang="ts">
import TextInput from "../../../../../components/FormComponents/TextInput.vue";
import {
  defineComponent,
  ref,
  reactive,
  computed,
  watch,
  onMounted,
} from "vue";
import common from "../../../Service/CommonService";
import { useRoute, useRouter } from "vue-router";
import TextArea from "../../../../../components/FormComponents/TextArea.vue";
import Dropdown from "../../../../../components/FormComponents/Dropdown.vue";

export default defineComponent({
  components: {
    TextInput,
    TextArea,
    Dropdown
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
    storeDetails: {
      type: Object,
      default: {},
    },
    DocNo: {
      type: String,
    },
    codeTitle: {
      type: String,
      default: "requestid",
    },
    Remarks: {
      type: String,
    },
    modelValue: {
      type: Object,
    },
    EntityId: {
      type: Number,
    },
    UrgentFlag: {
      type: Boolean,
      default: true,
    },
    IndentFlag: {
      type: Boolean,
      default: true,
    },
    CategoryHide: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    debugger;
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    const storeForm = reactive({
      FromStore: 0,
      FromStoreName: "",
      ToStore: 0,
      ToStoreName: "",
      FromStoreCode: "",
      ToStoreCode: "",
    });
    const requestData = reactive({
      DocNo: "",
      Remarks: "",
      Remarkscheck: ref(),
      Category: 1,

    });

    watch(
      () => props.modelValue,
      (newVal: any) => {
        debugger;
        requestData.DocNo = newVal["DocNo"];
        requestData.Remarks = newVal["Remarks"];
        update();
      }
    );

    const route = useRoute();
    const EditRequestId = route.query.Id;
    if (!EditRequestId) {
      debugger;
      GetCode();
    } else {
      requestData.DocNo = props.storeDetails["DocNo"];

      update();
    }

    onMounted(() => {
      debugger;
      LoadFrequestRequestID()
    });

    async function GetCode() {
      debugger;
      let data = {
        //FormId: 27,
        EntityId: props.EntityId,
        HospitalId: HospitalId,
        BranchId: route.query.BranchId ?? 0,
        StoreId: route.query.StoreId ?? 0
      };

      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      requestData.DocNo = result;
      update();
    }
    function update() {
      debugger;
      emit("update:modelValue", requestData);

    }
    function checkboxupdate() {
      debugger;
      requestData.Remarkscheck == true ? requestData.Remarks = "Urgent Request" : requestData.Remarks = "";
    }
    const Request = ref({
      category: [],
    });

    async function LoadFrequestRequestID() {
      debugger;

      try {
        const result = await common.RequestCategoryList();
        if (result["result"].length > 0) {
          Request.value.category = result["result"].map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        }

        console.log(result);
      } catch (error) {
        console.log(error);
      }
    }
    return {
      Request,
      checkboxupdate,
      storeForm,
      update,
      requestData,
    };
  },
});
</script>
<style>
.location-icon1 {
  width: 25px;
  height: 25px;
  position: absolute;
  top: -13px;
  left: -5px;
}

.location-icon2 {
  width: 25px;
  height: 25px;
  position: absolute;
  right: -5px;
  top: -13px;
}

.location-line {
  border-top: dotted #e1e1e1;
}
</style>
